import { Box } from '@mui/material';
import { keyframes, styled } from '@mui/material/styles';
import React from 'react';

const bounce = keyframes`
  0%, 80%, 100% {
    transform: scale(0);
  } 
  40% {
    transform: scale(1);
  }
`;

const Dot = styled(Box)(({ theme }) => ({
  width: '4px',
  height: '4px',
  margin: '0 4px',
  backgroundColor: theme.palette.text.primary,
  borderRadius: '50%',
  display: 'inline-block',
  animation: `${bounce} 1.4s infinite ease-in-out both`,
}));

const Dot1 = styled(Dot)({
  animationDelay: '0s',
});

const Dot2 = styled(Dot)({
  animationDelay: '0.2s',
});

const Dot3 = styled(Dot)({
  animationDelay: '0.4s',
});

const TypingIndicatorWrapper = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '16px',
});

const TypingIndicator = (): JSX.Element => {
  return (
    <TypingIndicatorWrapper>
      <Dot1 />
      <Dot2 />
      <Dot3 />
    </TypingIndicatorWrapper>
  );
};

export default TypingIndicator;
